/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for creating a competition. Ordinal is auto-assigned if not provided.
 * @export
 * @interface CompetitionCreate
 */
export interface CompetitionCreate {
    /**
     * 
     * @type {string}
     * @memberof CompetitionCreate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionCreate
     */
    ordinal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitionCreate
     */
    league_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitionCreate
     */
    season_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionCreate
     */
    is_public?: boolean;
}

/**
 * Check if a given object implements the CompetitionCreate interface.
 */
export function instanceOfCompetitionCreate(value: object): value is CompetitionCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompetitionCreateFromJSON(json: any): CompetitionCreate {
    return CompetitionCreateFromJSONTyped(json, false);
}

export function CompetitionCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'league_id': json['league_id'] == null ? undefined : json['league_id'],
        'season_id': json['season_id'] == null ? undefined : json['season_id'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
    };
}

export function CompetitionCreateToJSON(json: any): CompetitionCreate {
    return CompetitionCreateToJSONTyped(json, false);
}

export function CompetitionCreateToJSONTyped(value?: CompetitionCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ordinal': value['ordinal'],
        'league_id': value['league_id'],
        'season_id': value['season_id'],
        'is_public': value['is_public'],
    };
}

